import { http } from 'http/index'
// import { UserType } from 'services/user/type.d'
import { UserAzureType } from 'services/user/type.d'
import store from 'redux/store'
import { setCurrentUser } from 'redux/reducers/userSlice'
import ApiService from 'services/api'
import { setCurrentListNotAccess } from 'redux/reducers/listAccessSlice'
import { setCurrentListCountry } from 'redux/reducers/listCountrySlice'
import { setCurrentListCountriesAccess } from 'redux/reducers/listCountriesAccessSlice'
import { setCurrentPrevPath } from 'redux/reducers/prevPathSlice'

export class UserService extends ApiService {
  getAllUsers(): Promise<any> {
    return http.fetch('/admin/relationship-managers')
  }

  getAllImplementationManager(): Promise<any> {
    return http.fetch('/admin/implementation-managers')
  }

  getPublicContent(): Promise<any> {
    return http.get('/all')
  }

  getUserBoard(): Promise<any> {
    return http.get('/user')
  }

  getModeratorBoard(): Promise<any> {
    return http.get('/mod')
  }

  getAdminBoard(): Promise<any> {
    return http.get('/admin')
  }

  getListModuleNotAccess(): Promise<any> {
    return http.get('/admin/un-access-groups')
  }

  getListCountriesAccess(): Promise<any> {
    return http.get('/admin/groups-countries')
  }

  // loadUserFromLocalStorage(): UserType | null {
  loadUserFromLocalStorage(): UserAzureType | null {
    const userJson: string = localStorage.getItem('user') || ''
    // let user: UserType | null = null
    let user: UserAzureType | null = null
    if (userJson) {
      user = JSON.parse(userJson)
    }

    return user || null
  }

  handleOnReceivedBroadcastLogin(): void {
    // const user: UserType | null = this.loadUserFromLocalStorage()
    const user: UserAzureType | null = this.loadUserFromLocalStorage()
    this.setCurrentUser(user)
  }

  // pickCompactUserFromCognito(user: UserType | null): UserType | null {
  pickCompactUserFromCognito(user: UserAzureType | null): UserAzureType | null {
    return user
  }
  // setCurrentUser(user: UserType | null): void {
  //   const compactUser: UserType | null = this.pickCompactUserFromCognito(user)
  setCurrentUser(user: UserAzureType | null): void {
    const compactUser: UserAzureType | null =
      this.pickCompactUserFromCognito(user)
    store.dispatch(setCurrentUser(compactUser))
    localStorage.setItem('user', JSON.stringify(compactUser))
  }

  removeCurrentUser(): void {
    localStorage.removeItem('user')
    store.dispatch(setCurrentUser(null))
  }

  removePrevious(): void {
    sessionStorage.removeItem('prevPath')
    store.dispatch(setCurrentPrevPath(null))
  }

  removeListNonAccess(): void {
    localStorage.removeItem('listNonAccess')
    store.dispatch(setCurrentListNotAccess(null))
  }

  removeListCountry(): void {
    store.dispatch(setCurrentListCountry(null))
    store.dispatch(setCurrentListCountriesAccess(null))
  }

  getTokenFromLocalStorage(): string {
    // const user: UserType | null = this.loadUserFromLocalStorage()
    const token: string | null = localStorage.getItem('idToken')

    // return (user && user?.signInUserSession?.idToken?.jwtToken) || ''
    return token ? token : ''
  }
}
// eslint-disable-next-line
export default new UserService()
